import axios from 'axios';
import { environment } from '../config/environment';


const BASE_URL = `${environment.apiUrl}/auth`;


const AUTH_ENDPOINTS = {
  LOGIN: `${BASE_URL}/login`,
  VERIFY_OTP: `${BASE_URL}/verify-otp`,
  REFRESH_TOKEN: `${BASE_URL}/refresh-token`,
  VALIDATE_TOKEN: `${BASE_URL}/validate-token`,
};



export const loginUser = async (email, password) => {
  try {
    const response = await axios.post(AUTH_ENDPOINTS.LOGIN, { email, password });

    if (response.data.success) {
      return response.data;
    }

    throw new Error(response.data.errorMessage);

  } catch (error) {
    throw new Error(error.response?.data?.errorMessage || 'Login failed');
  }
};


export const verifyOtp = async (email, otp) => {
  try {
    const response = await axios.post(AUTH_ENDPOINTS.VERIFY_OTP, null, {
      params: { email, otp },
    });

    if (response.data.success) {
      return {
        accessToken: response.data.data.accessToken,
        refreshToken: response.data.data.refreshToken,
        role: response.data.data.role,
      };
    }

    throw new Error(response.data.errorMessage);

  } catch (error) {
    throw new Error(error.response?.data?.errorMessage || 'OTP verification failed');
  }
};



export const refreshAccessToken = async (refreshToken) => {
  const response = await axios.post(AUTH_ENDPOINTS.REFRESH_TOKEN, { refreshToken });

  if (response.data.data?.accessToken) {
    return { accessToken: response.data.data.accessToken };
  }

  throw new Error('Token refresh failed');
};


export const validateToken = async () => {

  const token = localStorage.getItem('bgc_token');

  if (!token) throw new Error('No token');

  const response = await axios.get(AUTH_ENDPOINTS.VALIDATE_TOKEN, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data === true;
};